import React, { Component } from "react";

export class ProfileTeamView extends Component {
  render() {
    return (
      <div>
        <h1>Profile Page - Team</h1>
      </div>
    );
  }
}
export default ProfileTeamView;
